// extracted by mini-css-extract-plugin
export default {"root":"MainTitle_root__a-GGD","title":"MainTitle_title__k2iVV","title_count":"MainTitle_title_count__xh6CY","title_selected":"MainTitle_title_selected__uLrxV"};